(function( $ ) {

    /******************************
     * Single page Plugin
     *
     * @returns {jQuery}
     */
    $.fn.single = function() {

        var $articles = $(this).find('article');

        $articles.each(function( i, article ) {
            checkTitle(article);
            checkImg(article);
        });

        /**
         * Check double h1 title
         * @access private
         */
        function checkTitle( article ) {

            var h1article = $(article).find('.article-content h1').first();
            
            if( $(h1article).length > 0 ) {
                var h1title = $(article).find('h1.article-title .article-title-text');
                
                if( $(h1title).html().trim() == $(h1article).html().trim() ) {
                    $(h1article).remove();
                }
            }
        }

        /**
         * Check for images
         * @access private
         */
        function checkImg( article ) {
            $(article).find('img').each(function( i, img ) {
                $(img).parent().addClass('has-image');
            });
        }

        return this;
    };

    $('body.single').single();

}(jQuery));